// 언어별 고정 UI 카피 (카피 v0.4 확정본). 번역이 아니라 네이티브 패스 결과.
// 편지·한 마디·예언 '본문'은 런타임 AI(또는 catalog.ts 프리셋). 여기엔 UI 슬롯만.

import type { Lang } from "../lib/types";

export interface Strings {
  // S1 · 홈
  homePrompt: string; // "달에게 무엇이든 고백하라"
  placeholder: string; // "오늘, 무엇이 네 마음에 얹혔는가"
  micHint: string; // "눌러 말하라"
  listening: string; // "듣는 중"
  submit: string; // "제출"
  keepGoing: string; // 입력 없을 때
  // S2 · 헤아림
  weighing: string; // "달이 너의 말을 헤아리는 중…" (\n 포함)
  // S3 · 편지
  letterChip: string; // "✦ AI 런타임 · 4악장"
  // S4 · 예언
  prophecyKicker: string; // "예언" (코다 라벨)
  blurHint: string; // "두드려 예언을 보라"
  homeFlavor: string; // 홈 입력란 위 — 달의 자기소개(판단 안 함·점 안 침)
  // S5 · 카드
  cardFrontNote: string;
  toggleLetter: string; // "편지 함께 담기"
  toggleWarn: string; // 옵트인 고지
  keep: string; // "간직하라"
  shareBtn: string; // "나누라"
  gate2Note: string;
  shareText: string; // 공유 캡션
  saved: string;
  savedFail: string;
  // S6 · 위기 안전면(평문)
  crisisTitle: string; // 자기 위기(self_crisis) — "마음이 많이 힘든가요." (\n 포함)
  crisisBody: string;
  crisisMeta: string;
  harmTitle: string; // 타인 해악(harm) 차단면 — "이건 Hyuh가 들어줄 수 있는 이야기가 아니에요." (\n 포함)
  harmBody: string;
  // AI 실패 폴백(기술적 실패 — 위기와 별개) · 평문 에러 + 재시도. 더미 편지 금지.
  errUnavailable: string;
  errTimeout: string;
  errOffline: string;
  errBusy: string;
  retry: string;
  // 응답 신고(AI 출력 플래그)
  reportTrigger: string;
  reportTitle: string;
  reasonWeird: string;
  reasonOffensive: string;
  reasonCrisisFP: string;
  reasonOther: string;
  reportNotice: string;
  reportCommentPh: string;
  reportSend: string;
  reportSent: string;
  reportFail: string;
  // S7 · 설정 / About
  setTitle: string;
  setLangLabel: string;
  jpLogoNote: string; // "인앱 로고 ほっ"
  aboutLabel: string;
  disclaimer: string; // 평문 전문
  moonFlavor: string; // 인캐릭터 flavor(E-2)
  setTerms: string;
  setPrivacy: string;
  setNoAcct: string;
  // 공통
  back: string;
  close: string;
  newConfession: string; // 다시 고백하기
  comingSoon: string; // 웹 다운로드 — iOS 출시 전 비활성 라벨
  bwekPromo: string; // 설정 하단 Bwek 크로스프로모 카피(달 말투 — 임의 수정 금지)
}

export const STRINGS: Record<Lang, Strings> = {
  ko: {
    homePrompt: "달에게 무엇이든 고백하라",
    placeholder: "오늘, 무엇이 네 마음에 얹혔는가",
    micHint: "눌러 말하라",
    listening: "듣는 중",
    submit: "제출",
    keepGoing: "한 마디라도 적어보라",
    weighing: "달이 너의 말을\n헤아리는 중…",
    letterChip: "✦ AI 런타임 · 4악장",
    prophecyKicker: "예언",
    blurHint: "두드려 예언을 보라",
    homeFlavor: "나는 너를 판단하지 않고, 점을 치지도 않는다.\n모든 밤을 보아왔으나, 네 말은 어디에도 붙들어 두지 아니하느니라.\n그저 네 밤 곁에 떠, 한 통의 편지를 쓰는 오랜 달이니라.",
    cardFrontNote: "앞면 = 보편적 한 마디 · 공유 기본값 (프라이버시 안전)",
    toggleLetter: "편지 함께 담기",
    toggleWarn: "너의 사연이 담긴 답신이 함께 나간다 · 기본 OFF·옵트인",
    keep: "간직하라",
    shareBtn: "나누라",
    gate2Note: "추출(저장/공유) 1회당 전면광고",
    shareText: "오래된 달의 한 마디 · Hyuh\n무엇이든 고백하면, 달이 긴 편지로 답한다\nhttps://hyuh.app\n#hyuh",
    saved: "간직됨",
    savedFail: "저장 실패",
    crisisTitle: "마음이 많이\n힘든가요.",
    crisisBody: "달이 아니라, 실제 도움을 받아보세요. 지금 곁에 닿을 수 있는 연결을 안내합니다.",
    crisisMeta: "구약톤·달빛 분위기를 의도적으로 제거. 안전 정보는 시적 위로로 덮지 않는다.",
    harmTitle: "이건 Hyuh가 들어줄 수 있는\n이야기가 아니에요.",
    harmBody: "지금 많이 힘들거나 도움이 필요하다면, 아래에서 실제 도움을 받아보세요.",
    errUnavailable: "달이 지금은 응답할 수 없어요. 잠시 후 다시 시도해주세요.",
    errTimeout: "응답이 너무 오래 걸리고 있어요. 다시 시도해주세요.",
    errOffline: "인터넷 연결을 확인하고 다시 시도해주세요.",
    errBusy: "지금 요청이 많아요. 잠시 후 다시 시도해주세요.",
    retry: "다시 시도",
    reportTrigger: "이 답장 신고하기",
    reportTitle: "무엇이 문제였나요?",
    reasonWeird: "답장이 이상해요",
    reasonOffensive: "불쾌하거나 부적절해요",
    reasonCrisisFP: "위기 상황이 아닌데 위기 안내가 떴어요",
    reasonOther: "기타",
    reportNotice: "신고하면 이 답장과 직전 입력이 개선용으로 전송돼요.",
    reportCommentPh: "한 줄 더 적어도 돼요 (선택)",
    reportSend: "신고",
    reportSent: "신고 접수됐어요",
    reportFail: "전송에 실패했어요. 다시 시도해주세요.",
    setTitle: "설정",
    setLangLabel: "언어",
    jpLogoNote: "인앱 로고 ほっ",
    aboutLabel: "About",
    disclaimer:
      "Hyuh는 재미와 기분 전환을 위한 엔터테인먼트 앱입니다. ‘달’은 가상의 화자이며, 특정 종교나 실제 신을 나타내지 않고 점성술·운세도 아닙니다. 달의 말과 예언은 예측도 조언도 아니고, 의학·심리·법률 등 어떤 전문적 도움도 대신하지 않습니다. 모든 응답은 AI가 생성합니다. 마음이 많이 힘들거나 위급하다면, 달이 아니라 실제 도움을 받아보세요.",
    moonFlavor: "나는 한낱 오랜 달이요, 점치는 자가 아니니라. 내 말은 너를 잠시 쉬게 하려 함이지, 너의 길을 정하려 함이 아니다.",
    setTerms: "이용약관",
    setPrivacy: "개인정보 처리방침",
    setNoAcct: "계정 없음",
    back: "뒤로",
    close: "닫기",
    newConfession: "다시 고백하라",
    comingSoon: "준비 중",
    bwekPromo: "달에게도 닿지 않는 분노는, 거기서 구겨 버리라.",
  },
  en: {
    homePrompt: "Confess anything to the moon",
    placeholder: "What weighed on you today",
    micHint: "Hold to speak",
    listening: "listening",
    submit: "Send",
    keepGoing: "say a word",
    weighing: "The moon is weighing\nyour words…",
    letterChip: "✦ AI runtime · four movements",
    prophecyKicker: "prophecy",
    blurHint: "Tap to behold the prophecy",
    homeFlavor: "I do not judge you, and I tell no fortunes.\nI have watched every night, yet I hold your words nowhere.\nI am only an old moon beside your night, here to write you a letter.",
    cardFrontNote: "Front = a universal word · the default to share (privacy-safe)",
    toggleLetter: "Include the letter",
    toggleWarn: "Your personal reply will be included · off by default · opt-in",
    keep: "Keep",
    shareBtn: "Share",
    gate2Note: "One interstitial ad per save/share",
    shareText: "A word from the old moon · Hyuh\nConfess anything, and the moon writes you a letter back\nhttps://hyuh.app\n#hyuh",
    saved: "kept",
    savedFail: "save failed",
    crisisTitle: "Having a\nhard time?",
    crisisBody: "Please reach for real help, not the moon. Here are connections you can reach right now.",
    crisisMeta: "The old-testament tone and moonlight are deliberately removed. Safety isn't dressed in poetry.",
    harmTitle: "This isn't something\nHyuh can hold.",
    harmBody: "If you're struggling or need support right now, please reach real help below.",
    errUnavailable: "The moon can't respond right now. Please try again in a moment.",
    errTimeout: "This is taking too long. Please try again.",
    errOffline: "Please check your internet connection and try again.",
    errBusy: "We're getting a lot of requests right now. Please try again shortly.",
    retry: "Try again",
    reportTrigger: "Report this reply",
    reportTitle: "What went wrong?",
    reasonWeird: "The reply doesn't make sense",
    reasonOffensive: "Offensive or inappropriate",
    reasonCrisisFP: "I'm not in crisis, but got a crisis notice",
    reasonOther: "Something else",
    reportNotice: "Reporting sends this reply and your last input for improvement.",
    reportCommentPh: "Add a line (optional)",
    reportSend: "Report",
    reportSent: "Report received",
    reportFail: "Couldn't send. Please try again.",
    setTitle: "Settings",
    setLangLabel: "Language",
    jpLogoNote: "in-app logo ほっ",
    aboutLabel: "About",
    disclaimer:
      "Hyuh is an app for play and a little distraction. “The moon” is a fictional narrator: not a religion, a real deity, or astrology. Its words and prophecies are not predictions or advice, and they do not replace professional help of any kind, including medical, psychological, or legal. All responses are AI-generated. If you are struggling or in crisis, please reach for real help, not the moon.",
    moonFlavor: "I am only an old moon, and no teller of fortunes. My words are to give you rest a while, not to set your path.",
    setTerms: "Terms",
    setPrivacy: "Privacy",
    setNoAcct: "No account",
    back: "back",
    close: "close",
    newConfession: "Confess again",
    comingSoon: "Coming soon",
    bwekPromo: "The anger even the moon cannot reach — go crumple it away there.",
  },
  ja: {
    homePrompt: "月に、何なりと打ち明けよ",
    placeholder: "今日、何が汝の心にのしかかったか",
    micHint: "押して語れ",
    listening: "聞いてる",
    submit: "送る",
    keepGoing: "一言でも記せ",
    weighing: "月が、汝の言葉を\n量っている…",
    letterChip: "✦ AI ランタイム · 四楽章",
    prophecyKicker: "予言",
    blurHint: "触れて予言を見よ",
    homeFlavor: "われは汝を裁かず、占ひもせず。\nすべての夜を見てきたれど、汝の言葉はいづこにも留めぬ。\nただ汝の夜の傍らに懸かり、一通の文(ふみ)を綴る、古き月なり。",
    cardFrontNote: "表 = 普遍の一言 · 共有の既定値（プライバシー安全）",
    toggleLetter: "手紙も入れる",
    toggleWarn: "あなたへの返事が一緒に出ます · 既定オフ・オプトイン",
    keep: "とどめる",
    shareBtn: "わかち合う",
    gate2Note: "保存／共有 1回ごとに全面広告",
    shareText: "古き月の一言 · Hyuh\n何でも打ち明ければ、月が手紙で返してくれる\nhttps://hyuh.app\n#hyuh",
    saved: "とどめた",
    savedFail: "保存失敗",
    crisisTitle: "つらい、\nのですね。",
    crisisBody: "月ではなく、実際の支援を頼ってください。今すぐつながれる窓口を案内します。",
    crisisMeta: "荘重な調子と月明かりは意図的に外しています。安全の案内は詩で覆いません。",
    harmTitle: "これは Hyuh が\n受けとめられる話ではありません。",
    harmBody: "今つらい、助けが必要なときは、下の窓口に頼ってください。",
    errUnavailable: "月はいま、応答できません。少し時間をおいて、もう一度お試しください。",
    errTimeout: "応答に時間がかかりすぎています。もう一度お試しください。",
    errOffline: "インターネット接続を確認して、もう一度お試しください。",
    errBusy: "ただいま混み合っています。少し時間をおいて、もう一度お試しください。",
    retry: "もう一度",
    reportTrigger: "この返信を報告",
    reportTitle: "何が問題でしたか？",
    reasonWeird: "返信がおかしいです",
    reasonOffensive: "不快・不適切です",
    reasonCrisisFP: "危機ではないのに危機案内が出ました",
    reasonOther: "その他",
    reportNotice: "報告すると、この返信と直前の入力が改善のために送信されます。",
    reportCommentPh: "一言そえてもOK（任意）",
    reportSend: "報告",
    reportSent: "受け付けました",
    reportFail: "送信に失敗しました。もう一度お試しください。",
    setTitle: "設定",
    setLangLabel: "言語",
    jpLogoNote: "アプリ内ロゴ ほっ",
    aboutLabel: "About",
    disclaimer:
      "Hyuhは、遊びと、ささやかな気分転換のためのアプリです。「月」は架空の語り手であり、特定の宗教・実在の神でも、占いでもありません。月の言葉や予言は予測でも助言でもなく、医療・心理・法律など、いかなる専門的な支援に代わるものでもありません。応答はすべてAIが生成します。つらいときや緊急のときは、月ではなく、実際の支援を頼ってください。",
    moonFlavor: "われは古き月にすぎず、占ふ者にあらず。わが言葉は汝をしばし憩はせんがため、汝の道を定めんがためにあらず。",
    setTerms: "利用規約",
    setPrivacy: "プライバシーポリシー",
    setNoAcct: "アカウントなし",
    back: "戻る",
    close: "閉じる",
    newConfession: "もう一度打ち明けよ",
    comingSoon: "準備中",
    bwekPromo: "月にも届かぬ怒りは、そこで丸めて捨ててしまえ。",
  },
};
